<template>
  <div>
    <p class="resend-method-title">
      Escolha por qual meio quer receber o {{ isMobile ? 'código' : 'link' }} de verificação
    </p>

    <a class="resend-method" @click="() => resendUsingConfirmationType('SMS')">
      <div class="icon">
        <ChatAltIcon />
      </div>
      <div class="content">
        <p class="title">SMS</p>
        <p class="subtitle">
          No celular {{ hiddenPhone }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>

    <a class="resend-method last" @click="() => resendUsingConfirmationType('WHATSAPP')">
      <div class="icon">
        <img src="https://cdn.parcelex.com.br/assets/v3/icons/rounded-whatsapp-primary.svg">
      </div>
      <div class="content">
        <p class="title">Whatsapp</p>
        <p class="subtitle">
          No celular {{ hiddenPhone }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { ChatAltIcon } from '@vue-hero-icons/outline';
import { ChevronRightIcon } from '@vue-hero-icons/solid';

export default {
  name: 'resend-confirmation-options',
  components: {
    ChatAltIcon,
    ChevronRightIcon,
  },
  computed: {
    ...mapState('onboardingV2', [
      'isMobile',
      'phone',
      'chosenConfirmationResendType',
      'hiddenPhone',
    ]),
  },
  methods: {
    ...mapActions('onboardingV2', [
      'resendConfirmation',
      'setShowResendOptions',
    ]),
    ...mapMutations('onboardingV2', [
      'setChosenConfirmationResendType',
      'setResendConfirmationType',
      'setDisableTheResendCounter',
    ]),
    startResendCounter() {
      this.$emit('startResendCounter');
    },
    resendUsingConfirmationType(resendType) {
      this.$emit('chosenConfirmationOption', resendType);
      this.setResendConfirmationType(resendType);
      this.setChosenConfirmationResendType();
      this.startResendCounter();
      this.resendConfirmation();
      this.setShowResendOptions({ showResendOptions: false });
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .resend-method-title {
    font-family: 'Usual';
    font-size: 16px;
    line-height: 28px;
    color: var(--gray-900);
    margin: 44px 0 24px 0;
  }

  .resend-method {
    align-items: center;
    display: flex;
    gap: 16px;
    padding: 20px 0;
    cursor: pointer;

    &.last {
      border-top: 1px solid var(--gray-200);
    }
  }

  .resend-method .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background-color: var(--blue-200);
    color: var(--blue-400);
    border-radius: 50%;
  }

  .resend-method .content {
    flex: 1;
  }

  .resend-method .title {
    @extend .body-semi-bold;
    color: var(--gray-900);
  }

  .resend-method .subtitle {
    @extend .small-regular;
    color: var(--gray-500);
  }

  .resend-method .arrow {
    align-self: center;
    color: var(--gray-900);
  }

  .resend-code {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #36A3CA;
    margin-top: 24px;
    margin-bottom: 36px;
  }

  .option-title > img, > svg {
    margin: unset;
  }

  @media (min-width: $lg) {
   .resend-method-title {
      font-size: 16px;
      line-height: 24px;
      margin: 24px 0 20px 0;
    }
  }
</style>
